import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Reveal } from "../lib/ui";

/** The Football Ecosystem Framework, read from the backend so the language is identical everywhere. */
export const EcosystemFramework = ({ compact = false }) => {
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/ecosystem").then((r) => setD(r.data)).catch(() => setD(null));
  }, []);

  if (!d) return null;

  return (
    <section className="border-t border-zinc-900 bg-black py-20 md:py-28" data-testid="ecosystem-framework">
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <p className="overline text-ochre">The football ecosystem &mdash; {d.count} parts</p>
        <h2 className="display-2 mt-5 max-w-4xl">{d.lead}</h2>

        <div className="mt-14 space-y-14">
          {d.families.map((f, fi) => (
            <Reveal key={f.family} delay={Math.min(fi * 0.05, 0.2)}>
              <div data-testid={`ecosystem-family-${fi}`}>
                <div className="flex items-center gap-4">
                  <p className="mono text-[0.58rem] uppercase tracking-[0.22em] text-maasai">{f.family}</p>
                  <span className="h-px flex-1 bg-zinc-900" />
                </div>
                <div className="mt-6 grid gap-px bg-zinc-800 md:grid-cols-2">
                  {f.parts.map((p) => (
                    <div key={p.part} className="bg-black p-6 md:p-7" data-testid={`ecosystem-part-${p.part.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                      <h3 className="font-display text-base uppercase tracking-tight text-white md:text-lg">{p.part}</h3>
                      <p className="mt-3 text-sm leading-relaxed text-zinc-300">{p.definition}</p>
                      {compact ? null : (
                        <p className="mt-3 text-sm leading-relaxed text-zinc-500">{p.gap}</p>
                      )}
                      <div className="mt-4 flex flex-wrap gap-x-4 gap-y-2">
                        {p.where.map(([label, to]) => (
                          <Link
                            key={to}
                            to={to}
                            className="mono text-[0.55rem] uppercase tracking-[0.16em] text-zinc-500 transition-colors hover:text-ochre"
                          >
                            {label} &rarr;
                          </Link>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
